export default "__VITE_ASSET__DiZbn4e5__"